import { faInfoCircle } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import type { FC } from 'react';
import { Button } from 'src/components/buttons-and-actions/button';
import { DropdownTrigger } from 'src/components/buttons-and-actions/dropdown-trigger';
import { Tooltip } from 'src/components/overlay/tooltip';
import type { PricesInEURMWh } from 'src/pages/transport/auctions/details/helper';

type PriceUnitButtonProps = {
  pricesInEURMWh: PricesInEURMWh | null;
  precalculatedPricesInEURMWh: PricesInEURMWh | null;
  setPricesInEURMWh: (value: PricesInEURMWh | null) => void;
};

export const PriceUnitButton: FC<PriceUnitButtonProps> = ({
  pricesInEURMWh,
  precalculatedPricesInEURMWh,
  setPricesInEURMWh,
}) => {
  return (
    <div className="grid grid-flow-col items-center gap-sm">
      {pricesInEURMWh && (
        <Tooltip
          dataTestId="eurMwh"
          content={
            <small>
              The value presented in EUR/MWh is indicative, representing the
              pro-rated capacity charge. This calculation assumes full
              utilization of the capacity throughout the entire runtime and
              incorporates the starting price reflecting the regulated tariff as
              uploaded by the TSOs.
            </small>
          }
        >
          {(targetProps) => (
            <FontAwesomeIcon icon={faInfoCircle} {...targetProps} />
          )}
        </Tooltip>
      )}

      <DropdownTrigger
        mode="secondary"
        size="sm"
        label={pricesInEURMWh ? 'EUR/MWh' : 'Original Unit'}
        data-testid="pricing-card-dropdown"
      >
        <Button
          onClick={() => setPricesInEURMWh(null)}
          isActive={!pricesInEURMWh}
          data-testid="original-unit-button"
        >
          Original Unit
        </Button>

        <Tooltip
          content={
            !precalculatedPricesInEURMWh && (
              <span>
                The exchange rates could not be loaded. Please try again later.
              </span>
            )
          }
        >
          {(targetProps) => (
            <Button
              onClick={() => setPricesInEURMWh(precalculatedPricesInEURMWh)}
              isActive={Boolean(pricesInEURMWh)}
              data-testid="original-unit-to-eur-button"
              disabled={!precalculatedPricesInEURMWh}
              {...targetProps}
            >
              EUR/MWh
            </Button>
          )}
        </Tooltip>
      </DropdownTrigger>
    </div>
  );
};
